import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'transport_mean',
	'el medio de transporte',
	'los medios de transporte'
)

const getTransportMeansData = (options) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/transport_mean/utils/get_transport_means_data`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})
		dispatch({
			type: 'LOAD_TRANSPORT_MEANS',
			response: res.body,
		})
		return res.body
	}
}

const createTransportMean = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/transport_mean/create_transport_mean`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se agregó el medio de transporte correctamente.',
		})

		dispatch({
			type: 'ADD_TRANSPORT_MEAN',
			response: res.body,
		})
		return res.body
	}
}

const updateTransportMean = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/transport_mean/update_transport_mean`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se actualizó el medio de transporte correctamente.',
		})

		dispatch({
			type: 'UPDATE_TRANSPORT_MEAN',
			response: res.body?.id ? res.body : item,
		})
		return res.body
	}
}

const getTransportMeanById = (id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(
			`/transport_mean/utils/get_transport_mean_data/${id}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)
		dispatch({
			type: 'LOAD_TRANSPORT_MEAN',
			response: res.body,
		})
		return res.body
	}
}

const deleteTransportMean = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/transport_mean/utils/delete_transport_mean`, {
			method: 'DELETE',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),

			successMessage: 'Se eliminó el medio de transporte correctamente.',
		})

		dispatch({
			type: 'DELETE_TRANSPORT_MEAN',
			response: res.body?.id ? res.body : item,
		})
		return res.body
	}
}

export default {
	...actions,
	getTransportMeansData,
	createTransportMean,
	updateTransportMean,
	getTransportMeanById,
	deleteTransportMean,
}
